// extracted by mini-css-extract-plugin
export default {"search":"SearchInput_search__WUM+J","icon":"SearchInput_icon__WgvMS"};